var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowModal,
            expression: "isShowModal"
          }
        ],
        staticClass: "overlay",
        on: { click: _vm.clickOnOverlay }
      },
      [
        _c("transition", { attrs: { name: _vm.animationType } }, [
          _vm.isShowModal
            ? _c(
                "div",
                { class: ["wrap", { center: _vm.centerContent }] },
                [_vm._t("default")],
                2
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileModal.vue?vue&type=template&id=63b7635b&scoped=true&
// module id = null
// module chunks = 